import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { withQuery, withMutation } from '../../../hoc/withGraphql';
import getAllCampaigns from './getAllCampaigns.graphql';
import estimateSegmentQ from './estimateSegment.graphql';
import getReferrals from './getReferrals.graphql';
import getReferralSettings from './getReferralSettings.graphql';
import sendCampaignM from './sendCampaign.graphql';
import saveReferralSettingsM from './saveReferralSettings.graphql';

const RED = '#D32F2F';
const INK = '#1F2733';
const TEAL = '#0E9488';

const SEGMENTS = [
  { v: 'all_customers', l: 'All customers' },
  { v: 'all_providers', l: 'All providers' },
  { v: 'inactive_customers', l: 'Inactive customers (no booking 60d)' },
];

class GrowthMarketing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'campaigns', busy: false, message: '',
      segment: 'all_customers', subject: '', body: '', estimate: null,
      refSeeded: false, enabled: false, currency: 'USD',
      clientClient: '', clientWorker: '', workerClient: '', workerWorker: '', welcomeClient: '', welcomeWorker: '',
      campaignsPage: 1, referralsPage: 1,
    };
  }

  goCampaigns = (delta) => this.setState((s) => ({ campaignsPage: Math.max(1, s.campaignsPage + delta) }), () => this.props.campaigns.refetch({ currentPage: this.state.campaignsPage }));
  goReferrals = (delta) => this.setState((s) => ({ referralsPage: Math.max(1, s.referralsPage + delta) }), () => this.props.referrals.refetch({ currentPage: this.state.referralsPage }));

  componentDidUpdate() {
    const s = this.props.refSettings && this.props.refSettings.getReferralSettings;
    if (!this.state.refSeeded && s && s.status === 200) {
      const v = (x) => (x != null ? String(x) : '');
      this.setState({
        refSeeded: true,
        enabled: !!s.enabled,
        clientClient: v(s.clientClient), clientWorker: v(s.clientWorker),
        workerClient: v(s.workerClient), workerWorker: v(s.workerWorker),
        welcomeClient: v(s.welcomeClient), welcomeWorker: v(s.welcomeWorker),
        currency: s.currency || 'USD',
      });
    }
  }

  estimate = async () => {
    this.setState({ busy: true, message: '', estimate: null });
    try {
      const r = await this.props.segmentEstimate.refetch({ segment: this.state.segment });
      const c = r && r.data && r.data.estimateSegment;
      this.setState({ busy: false, estimate: c ? c.count : 0 });
    } catch (e) { this.setState({ busy: false, message: e.message }); }
  };

  send = async () => {
    if (!this.state.subject || !this.state.body) { this.setState({ message: 'Subject and message are required.' }); return; }
    const seg = SEGMENTS.find((x) => x.v === this.state.segment);
    if (!window.confirm(`Send this email campaign to "${seg ? seg.l : this.state.segment}"? This sends real emails.`)) return;
    this.setState({ busy: true, message: '' });
    try {
      const res = await this.props.sendCampaignMut({ variables: { segment: this.state.segment, subject: this.state.subject, message: this.state.body } });
      const r = res && res.data && res.data.sendCampaign;
      if (r && r.status === 200) {
        const c = r.results && r.results[0];
        this.setState({ busy: false, message: `✅ Sent to ${c ? c.sent : 0} recipient(s)${c && c.failed ? `, ${c.failed} failed` : ''}.`, subject: '', body: '', estimate: null });
        this.props.campaigns.refetch();
      } else {
        this.setState({ busy: false, message: (r && r.errorMessage) || 'Campaign failed.' });
      }
    } catch (e) { this.setState({ busy: false, message: e.message }); }
  };

  saveSettings = async () => {
    this.setState({ busy: true, message: '' });
    try {
      const f = (x) => parseFloat(this.state[x]) || 0;
      const res = await this.props.saveSettingsMut({ variables: {
        enabled: this.state.enabled,
        clientClient: f('clientClient'), clientWorker: f('clientWorker'),
        workerClient: f('workerClient'), workerWorker: f('workerWorker'),
        welcomeClient: f('welcomeClient'), welcomeWorker: f('welcomeWorker'),
        currency: this.state.currency || 'USD',
      } });
      const r = res && res.data && res.data.saveReferralSettings;
      this.setState({ busy: false, message: r && r.status === 200 ? '✅ Referral settings saved.' : ((r && r.errorMessage) || 'Save failed.') });
    } catch (e) { this.setState({ busy: false, message: e.message }); }
  };

  render() {
    const input = { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginRight: 8 };
    const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', padding: '8px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer', marginRight: 8 });
    const card = { background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 16, marginBottom: 16 };
    const tabBtn = (t) => ({ ...btn(this.state.tab === t ? RED : '#fff'), color: this.state.tab === t ? '#fff' : INK, border: this.state.tab === t ? 'none' : '1px solid #ddd' });
    const th = { padding: 10, textAlign: 'left' };
    const td = { padding: 10, borderTop: '1px solid #f0f0f0', fontSize: 13 };

    const campaigns = (this.props.campaigns && this.props.campaigns.getAllCampaigns && this.props.campaigns.getAllCampaigns.results) || [];
    const referrals = (this.props.referrals && this.props.referrals.getReferrals && this.props.referrals.getReferrals.results) || [];
    const campaignsCount = (this.props.campaigns && this.props.campaigns.getAllCampaigns && this.props.campaigns.getAllCampaigns.count) || 0;
    const referralsCount = (this.props.referrals && this.props.referrals.getReferrals && this.props.referrals.getReferrals.count) || 0;
    const PAGE_SIZE = 15;

    return (
      <div style={{ fontFamily: 'Poppins, sans-serif' }}>
        <h1 className="siteAdminPrimaryHeading">Growth</h1>

        <div style={{ marginBottom: 16 }}>
          <button style={tabBtn('campaigns')} onClick={() => this.setState({ tab: 'campaigns', message: '' })}>Campaigns</button>
          <button style={tabBtn('referral')} onClick={() => this.setState({ tab: 'referral', message: '' })}>Referral program</button>
          {this.state.message ? <span style={{ marginLeft: 12, color: RED, fontWeight: 600 }}>{this.state.message}</span> : null}
        </div>

        {this.state.tab === 'campaigns' && (
          <div>
            <div style={card}>
              <div style={{ fontWeight: 700, marginBottom: 10 }}>New email campaign</div>
              <select style={input} value={this.state.segment} onChange={(e) => this.setState({ segment: e.target.value, estimate: null })}>
                {SEGMENTS.map((s) => <option key={s.v} value={s.v}>{s.l}</option>)}
              </select>
              <button style={btn(INK)} disabled={this.state.busy} onClick={this.estimate}>Estimate recipients</button>
              {this.state.estimate != null ? <span style={{ fontWeight: 700, color: TEAL }}>{this.state.estimate} recipient(s)</span> : null}
              <div style={{ marginTop: 10 }}>
                <input style={{ ...input, width: 420, display: 'block', marginBottom: 8 }} placeholder="Email subject" value={this.state.subject} onChange={(e) => this.setState({ subject: e.target.value })} />
                <textarea style={{ ...input, width: 600, height: 140 }} placeholder="Email message…" value={this.state.body} onChange={(e) => this.setState({ body: e.target.value })} />
              </div>
              <button style={btn(RED)} disabled={this.state.busy} onClick={this.send}>Send campaign</button>
              <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>Sends real emails to everyone in the segment. Test with a small segment first.</div>
            </div>

            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ padding: '10px 14px', fontWeight: 700, borderBottom: '1px solid #f0f0f0' }}>Campaign history</div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                <thead><tr style={{ background: '#fafafa' }}><th style={th}>Date</th><th style={th}>Segment</th><th style={th}>Subject</th><th style={th}>Recipients</th><th style={th}>Sent</th><th style={th}>Failed</th><th style={th}>By</th></tr></thead>
                <tbody>
                  {campaigns.length === 0 && <tr><td style={td} colSpan={7}>No campaigns sent yet.</td></tr>}
                  {campaigns.map((c) => (
                    <tr key={c.id}>
                      <td style={td}>{c.sentAt ? c.sentAt.slice(0, 10) : (c.createdAt ? c.createdAt.slice(0, 10) : '—')}</td>
                      <td style={td}>{c.segment}</td><td style={td}>{c.subject}</td>
                      <td style={td}>{c.recipients}</td><td style={td}>{c.sent}</td><td style={td}>{c.failed}</td>
                      <td style={td}>{c.adminEmail || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {campaignsCount > PAGE_SIZE && (
              <div style={{ marginTop: 14, display: 'flex', alignItems: 'center', gap: 12 }}>
                <button style={btn(RED)} disabled={this.state.campaignsPage <= 1} onClick={() => this.goCampaigns(-1)}>Prev</button>
                <span>Page {this.state.campaignsPage} / {Math.max(1, Math.ceil(campaignsCount / PAGE_SIZE))} ({campaignsCount})</span>
                <button style={btn(RED)} disabled={this.state.campaignsPage >= Math.ceil(campaignsCount / PAGE_SIZE)} onClick={() => this.goCampaigns(1)}>Next</button>
              </div>
            )}
          </div>
        )}

        {this.state.tab === 'referral' && (
          <div>
            <div style={card}>
              <div style={{ fontWeight: 700, marginBottom: 10 }}>Referral program settings</div>
              <label style={{ marginRight: 16, fontWeight: 600 }}>
                <input type="checkbox" checked={this.state.enabled} onChange={(e) => this.setState({ enabled: e.target.checked })} /> Program enabled
              </label>
              <label style={{ fontSize: 13, color: '#666', marginRight: 6 }}>Currency</label>
              <input style={{ ...input, width: 70 }} value={this.state.currency} onChange={(e) => this.setState({ currency: e.target.value.toUpperCase() })} />

              {(() => {
                const amt = (key, label, hint) => (
                  <div style={{ display: 'inline-block', marginRight: 18, marginTop: 12 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: INK }}>{label}</div>
                    <div style={{ fontSize: 11, color: '#999', marginBottom: 4 }}>{hint}</div>
                    <input style={{ ...input, width: 110 }} placeholder="0" value={this.state[key]}
                           onChange={(e) => this.setState({ [key]: e.target.value.replace(/[^0-9.]/g, '') })} />
                  </div>
                );
                return (
                  <div style={{ marginTop: 6 }}>
                    <div style={{ fontWeight: 700, color: '#0E9488', marginTop: 8 }}>Referrer rewards</div>
                    {amt('clientClient', 'Client → Client', 'wallet credit')}
                    {amt('clientWorker', 'Client → Worker', 'wallet credit')}
                    {amt('workerClient', 'Worker → Client', 'cash payout')}
                    {amt('workerWorker', 'Worker → Worker', 'cash payout')}
                    <div style={{ fontWeight: 700, color: '#0E9488', marginTop: 14 }}>Welcome bonus (new signup)</div>
                    {amt('welcomeClient', 'New client', 'wallet credit')}
                    {amt('welcomeWorker', 'New worker', 'cash payout')}
                  </div>
                );
              })()}

              <div style={{ marginTop: 14 }}>
                <button style={btn(RED)} disabled={this.state.busy} onClick={this.saveSettings}>Save settings</button>
              </div>
              <div style={{ fontSize: 12, color: '#888', marginTop: 8 }}>Reward destination follows the referrer's type: client → wallet credit (usable for jobs), worker → cash in next payout. Granted after the referee qualifies (1st paid order / 2 completed jobs) + a safety hold.</div>
            </div>

            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ padding: '10px 14px', fontWeight: 700, borderBottom: '1px solid #f0f0f0' }}>Referrals</div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                <thead><tr style={{ background: '#fafafa' }}><th style={th}>#</th><th style={th}>Referrer</th><th style={th}>Referee</th><th style={th}>Code</th><th style={th}>Status</th><th style={th}>Date</th></tr></thead>
                <tbody>
                  {referrals.length === 0 && <tr><td style={td} colSpan={6}>No referrals yet.</td></tr>}
                  {referrals.map((r) => (
                    <tr key={r.id}>
                      <td style={td}>{r.id}</td>
                      <td style={td}>
                        <div style={{ fontWeight: 600 }}>{r.referrerName || r.referrerId || '—'}</div>
                        <div style={{ fontSize: 12, color: '#666' }}>${(r.referrerAmount || 0)} {r.referrerRewardType || ''} · {r.referrerRewardPaid ? '✅ Paid' : '⏳ Pending'}</div>
                      </td>
                      <td style={td}>
                        <div style={{ fontWeight: 600 }}>{r.refereeName || r.refereeId || '—'}</div>
                        <div style={{ fontSize: 12, color: '#666' }}>${(r.refereeAmount || 0)} {r.refereeRewardType || ''} · {r.refereeRewardPaid ? '✅ Paid' : '⏳ Pending'}</div>
                      </td>
                      <td style={td}>{r.code || '—'}</td>
                      <td style={td}>{r.status}</td>
                      <td style={td}>{r.createdAt ? r.createdAt.slice(0, 10) : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {referralsCount > PAGE_SIZE && (
              <div style={{ marginTop: 14, display: 'flex', alignItems: 'center', gap: 12 }}>
                <button style={btn(RED)} disabled={this.state.referralsPage <= 1} onClick={() => this.goReferrals(-1)}>Prev</button>
                <span>Page {this.state.referralsPage} / {Math.max(1, Math.ceil(referralsCount / PAGE_SIZE))} ({referralsCount})</span>
                <button style={btn(RED)} disabled={this.state.referralsPage >= Math.ceil(referralsCount / PAGE_SIZE)} onClick={() => this.goReferrals(1)}>Next</button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default compose(
  withQuery(getAllCampaigns, { name: 'campaigns', options: { variables: { currentPage: 1 }, fetchPolicy: 'network-only', ssr: false } }),
  withQuery(estimateSegmentQ, { name: 'segmentEstimate', options: { variables: { segment: 'all_customers' }, fetchPolicy: 'network-only', ssr: false } }),
  withQuery(getReferrals, { name: 'referrals', options: { variables: { currentPage: 1 }, fetchPolicy: 'network-only', ssr: false } }),
  withQuery(getReferralSettings, { name: 'refSettings', options: { fetchPolicy: 'network-only', ssr: false } }),
  withMutation(sendCampaignM, { name: 'sendCampaignMut' }),
  withMutation(saveReferralSettingsM, { name: 'saveSettingsMut' }),
)(GrowthMarketing);
